import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainPage from './page/index';
import Policy from './page/policy';
import Terns from './page/terns_';
import Animations from './pages/Animations';
import Fashion from './pages/Fashion';
import NftGallery from './pages/NftGallery';




const Routing = () => {
    return (
        <Routes>
            <Route path='/' element={<MainPage />} />
            <Route path='/policy' element={<Policy />} />
            <Route path='/terns' element={<Terns />} />
            <Route path='/animations' element={<Animations />} />
            <Route path='/fashion' element={<Fashion />} />
            <Route path='/nft' element={<NftGallery />} />
        </Routes>
    );
};

export default Routing;
